import {createSlice} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import IView from "../../types/view";
import IRevision from "../../types/revision";
import IOption from "../../types/option";

export type TSearchState = {
    views: IView[]
    revisions: IRevision[]
    activeRevision: IRevision | null
    page: IOption | null
}

const initialState: TSearchState = {
    views: [],
    revisions: [],
    activeRevision: null,
    page: null
}

export const searchSlice = createSlice({
    name: 'search',
    initialState,
    reducers: {
        setViewsAction: (state, action: PayloadAction<IView[]>) => {
            state.views = action.payload
        },
        setRevisionsAction: (state, action: PayloadAction<IRevision[]>) => {
            state.revisions = action.payload
        },
        addRevisionsAction: (state, action: PayloadAction<IRevision[]>) => {
            state.revisions = state.revisions.concat(action.payload)
        },
        setRevisionAction: (state, action: PayloadAction<IRevision | null>) => {
            state.activeRevision = action.payload
        },
        setPageAction: (state, action: PayloadAction<IOption | null>) => {
            state.page = action.payload
        }
    }
})

export const {
    setViewsAction,
    setRevisionsAction,
    setRevisionAction,
    setPageAction,
    addRevisionsAction
} = searchSlice.actions
export default searchSlice.reducer